// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pf-report-wrapper {
  display: flex;
  justify-content: center;
  padding: 40px 20px;
  background-color: #f4f7f6;
  min-height: calc(100vh - 80px);
}

.pf-report-container {
  background: #ffffff;
  width: 100%;
  max-width: 800px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 30px 40px;
  height: fit-content;
}

.pf-report-header {
  border-bottom: 1px solid #eaeaea;
  padding-bottom: 20px;
  margin-bottom: 30px;
}

.pf-report-header h2 {
  font-size: 24px;
  color: #333333;
  margin: 0 0 8px 0;
  font-weight: 600;
}

.pf-report-header p {
  color: #777777;
  margin: 0;
  font-size: 14px;
}

.pf-report-form {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 24px;
  margin-bottom: 30px;
}

.pf-form-group {
  display: flex;
  flex-direction: column;
}

/* This successfully aligns your label and asterisk cleanly on one line */
.pf-form-group label {
  display: flex;
  gap: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #444444;
  margin-bottom: 8px;
  flex-direction: row;
  align-items: center; 
}

.pf-form-group .required {
  color: #e74c3c;
}

/* ⭐ STRICT COLOR RULES TO PREVENT LIGHT GREEN BLEEDING */
.pf-form-group select,
.pf-form-group select option {
  padding: 10px 14px;
  border: 1px solid #cccccc;
  border-radius: 6px;
  font-size: 14px;
  color: #333333 !important; /* Forces standard black/dark-grey text */
  background-color: #fafafa !important; /* Standardizes the background */
  outline: none;
  transition: all 0.3s ease;
  cursor: pointer;
}

.pf-form-group select:focus {
  border-color: #0056b3;
  background-color: #ffffff !important;
  box-shadow: 0 0 0 3px rgba(0, 86, 179, 0.1);
}

.pf-report-message {
  padding: 12px;
  border-radius: 6px;
  font-size: 14px;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 500;
}

.pf-report-message.error {
  background-color: #fdecea;
  color: #e74c3c;
  border: 1px solid #f5c6c2;
}

.pf-report-message.success {
  background-color: #eafaf1;
  color: #2ecc71;
  border: 1px solid #c2f0d5;
}

.pf-report-actions {
  display: flex;
  justify-content: flex-end;
}

.download-btn {
  background-color: #0056b3;
  color: #ffffff;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.download-btn:hover {
  background-color: #004494;
}

.download-btn:disabled {
  background-color: #a0c4e8;
  cursor: not-allowed;
}

/* Responsive Adjustments */
@media screen and (max-width: 600px) {
  .pf-report-container {
    padding: 20px;
  }

  .pf-report-form {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/AdminPanel/PfReport.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,yDAAyD;AACzD;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB,EAAE,yCAAyC;EACpE,oCAAoC,EAAE,gCAAgC;EACtE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".pf-report-wrapper {\n  display: flex;\n  justify-content: center;\n  padding: 40px 20px;\n  background-color: #f4f7f6;\n  min-height: calc(100vh - 80px);\n}\n\n.pf-report-container {\n  background: #ffffff;\n  width: 100%;\n  max-width: 800px;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  padding: 30px 40px;\n  height: fit-content;\n}\n\n.pf-report-header {\n  border-bottom: 1px solid #eaeaea;\n  padding-bottom: 20px;\n  margin-bottom: 30px;\n}\n\n.pf-report-header h2 {\n  font-size: 24px;\n  color: #333333;\n  margin: 0 0 8px 0;\n  font-weight: 600;\n}\n\n.pf-report-header p {\n  color: #777777;\n  margin: 0;\n  font-size: 14px;\n}\n\n.pf-report-form {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 24px;\n  margin-bottom: 30px;\n}\n\n.pf-form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n/* This successfully aligns your label and asterisk cleanly on one line */\n.pf-form-group label {\n  display: flex;\n  gap: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #444444;\n  margin-bottom: 8px;\n  flex-direction: row;\n  align-items: center; \n}\n\n.pf-form-group .required {\n  color: #e74c3c;\n}\n\n/* ⭐ STRICT COLOR RULES TO PREVENT LIGHT GREEN BLEEDING */\n.pf-form-group select,\n.pf-form-group select option {\n  padding: 10px 14px;\n  border: 1px solid #cccccc;\n  border-radius: 6px;\n  font-size: 14px;\n  color: #333333 !important; /* Forces standard black/dark-grey text */\n  background-color: #fafafa !important; /* Standardizes the background */\n  outline: none;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.pf-form-group select:focus {\n  border-color: #0056b3;\n  background-color: #ffffff !important;\n  box-shadow: 0 0 0 3px rgba(0, 86, 179, 0.1);\n}\n\n.pf-report-message {\n  padding: 12px;\n  border-radius: 6px;\n  font-size: 14px;\n  margin-bottom: 20px;\n  text-align: center;\n  font-weight: 500;\n}\n\n.pf-report-message.error {\n  background-color: #fdecea;\n  color: #e74c3c;\n  border: 1px solid #f5c6c2;\n}\n\n.pf-report-message.success {\n  background-color: #eafaf1;\n  color: #2ecc71;\n  border: 1px solid #c2f0d5;\n}\n\n.pf-report-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.download-btn {\n  background-color: #0056b3;\n  color: #ffffff;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.download-btn:hover {\n  background-color: #004494;\n}\n\n.download-btn:disabled {\n  background-color: #a0c4e8;\n  cursor: not-allowed;\n}\n\n/* Responsive Adjustments */\n@media screen and (max-width: 600px) {\n  .pf-report-container {\n    padding: 20px;\n  }\n\n  .pf-report-form {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
